import { Tooltip } from "react-tooltip";
const CsvButton = ({ data, name }) => {
  const exportarCSV = () => {
    const csvData = [];
    if (data[0]?.datos) {
      csvData.push(
        Object.keys(data[0].datos[0]).map((k) => {
          return k;
        })
      );

      data.forEach((row, i) => {
        row.datos.forEach((dato) => {
          csvData.push(
            Object.values(dato).map((v) => {
              return v;
            })
          );
        });
      });
    } else {
      csvData.push(
        Object.keys(data[0]).map((k) => {
          return k;
        })
      );
      data.forEach((row) => {
        csvData.push(
          Object.values(row).map((v) => {
            return v;
          })
        );
      });
    }

    const csvContent = "data:text/csv;charset=utf-8," + csvData.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", name);
    document.body.appendChild(link); // Required for FF

    link.click();
  };
  return (
    <>
      <button
        data-tooltip-id="csv-tooltip"
        data-tooltip-content="Exportar en Csv"
        className="border-0 bg-primary rounded mr-1 ml-1"
        onClick={exportarCSV}
      >
        <span className="text-white fontIcon">CSV</span>
      </button>
      <Tooltip id="csv-tooltip" />
    </>
  );
};

export default CsvButton;
